import SectionHero from "components/SectionHero/SectionHero";
import SectionSliderNewCategories from "components/SectionSliderNewCategories/SectionSliderNewCategories";
import SectionSubscribe2 from "components/SectionSubscribe2/SectionSubscribe2";
import SectionOurFeatures from "components/SectionOurFeatures/SectionOurFeatures";
import SectionGridFeaturePlaces from "../../components/Quasi/FeaturedSections/SectionGridFeaturePlaces";
import SectionHowItWork from "components/SectionHowItWork/SectionHowItWork";
import SectionFeaturedHolidayPackages from "../../components/Quasi/FeaturedSections/SectionFeaturedHolidayPackages";
import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import SectionBecomeAnAuthor from "components/SectionBecomeAnAuthor/SectionBecomeAnAuthor";
import SectionTrend from "components/SectionTrend/SectionTrend";
import SectionMood from "components/SectionMood/SectionMood";
import SectionPartners from "components/SectionPartners/SectionPartners";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import { USER_JOURNEY_DATA, TRENDS_DATA, MOOD_DATA, TESTIMONIALS_DATA } from "data/site_content";


function PageHome() {

  const { t, ready } = useTranslation("translation");

  if (!ready) return null;

  const translatedTrends = t("translation:home.trends.list", { returnObjects: true }) as any[];
  const translatedMoods = t("translation:home.moods.list", { returnObjects: true }) as any[];
  const translatedUserJourney = t("translation:home.userJourney.list", { returnObjects: true }) as any[];

  const assembledUserJourney = USER_JOURNEY_DATA.map(
    (item, index) => {
      return {
        id: index,
        img: item,
        title: translatedUserJourney[index].title,
        description: translatedUserJourney[index].description,
      }
    }
  );

  const assembledMoods = MOOD_DATA ? Object.keys(MOOD_DATA).map(
    (key, index) => {
      return {
        id: index,
        img: MOOD_DATA[key],
        title: translatedMoods[index].title,
        description: translatedMoods[index].description,
        actionButton: translatedMoods[index].actionButton,
      }
    }
  ) : [];

  const assembledTrends = TRENDS_DATA.map(
    (item, index) => {
      return {
        id: index,
        img: item,
        title: translatedTrends[index].title,
        description: translatedTrends[index].description,
        actionButton: translatedTrends[index].actionButton,
      }
    }
  );


  return (
    <div className="nc-PageHome relative overflow-hidden">

      <Helmet>
        <title>TRIBYOU</title>
        <meta name="description" content="Il tour operator digitale per team retreat, viaggi di lavoro e incentivi. Crea pacchetti dinamici o scegli dalla nostra selezione in pochi clic. Per aziende e remote worker. Entra nella nostra TribYou" />
        <link rel="canonical" href="https://www.tribyou.life/" />
      </Helmet>
      
      {/* SECTION */}
      <BgGlassmorphism />

      <div className="container relative space-y-24 mb-24 lg:space-y-28 lg:mb-28 flex flex-col">
        
        {/* SECTION HERO */}
        <SectionHero className="pt-10 lg:pt-16 lg:pb-16" />

        {/* SECTION */}
        <SectionOurFeatures />

        {/* SECTION RECOMMENDED PACKAGES */}
        <SectionFeaturedHolidayPackages />

        {/* SECTION RECOMMENDED PLACES */}
        <SectionGridFeaturePlaces
          heading={t("translation:home.highlightedDestinations.title")}
          subHeading={t("translation:home.highlightedDestinations.description")}
          headingIsCenter={true}
        />

        {/* SECTION */}
        <SectionHowItWork 
          heading={t("translation:home.userJourney.title")}
          description={t("translation:home.userJourney.description")}
          data={assembledUserJourney}
        />

        {/* SECTION */}
        <SectionSubscribe2 />

        {/* SECTION */}
        <div className="relative py-16">
          <BackgroundSection />
          <SectionBecomeAnAuthor />
        </div>

        {/* SECTION */}
        <SectionMood
          heading={t("translation:home.moods.title")}
          description={t("translation:home.moods.description")}
          data={assembledMoods}
        />
        
        {/* SECTION */}
        <SectionTrend 
          heading={t("translation:home.trends.title")}
          description={t("translation:home.trends.description")}
          data={assembledTrends}
        />

        {/* SECTION */}
        <SectionSliderNewCategories
          heading={t("translation:home.destinations.title")}
          subHeading={t("translation:home.destinations.description")}
          categoryCardType="card5"
          itemPerRow={5}
          uniqueClassName="PageHome_s3"
        />

        <SectionPartners />
      </div>
    </div>
  );
}

export default PageHome;
